import { Component, Input } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { FcinputComponent } from '../fcinput';
/* å¯ææ½çåå² */
@Component({
    selector: 'fc-divider',
    template: `
    <nz-divider [nzText]="fcLabel" [nzDashed]="_dashed" [nzType]="fcDirection" *ngIf="fcIcon===undefined" [nzOrientation]="fcPosition"></nz-divider>
    <nz-divider [nzDashed]="_dashed" [nzType]="fcDirection" fcLeftIcon="_leftIcon" [nzText]="text" fcLabel="fcLabel" *ngIf="fcIcon!==undefined && fcLeftIcon==='Y'">
        <ng-template #text> <i class="icon iconfont {{fcIcon}}" *ngIf="fcIcon!==undefined"></i> {{fcLabel}}</ng-template>
    </nz-divider>
    <nz-divider [nzDashed]="_dashed" [nzType]="fcDirection" fcRightIcon="_rightIcon" [nzText]="text" fcLabel="fcLabel" 
    *ngIf="fcIcon!==undefined &&fcRightIcon==='Y'&&fcDashed===undefined">
        <ng-template #text>{{fcLabel}} <i class="icon iconfont {{fcIcon}}" *ngIf="fcIcon!==undefined"></i></ng-template>
    </nz-divider>
    <nz-divider [nzDashed]="_dashed" [nzType]="fcDirection" fcRightIcon="_rightIcon" [nzText]="text" fcLabel="fcLabel" 
     *ngIf="fcIcon!==undefined &&fcRightIcon==='Y'&&fcDashed==='Y'">
        <ng-template #text>{{fcLabel}} <i class="icon iconfont {{fcIcon}}" *ngIf="fcIcon!==undefined"></i></ng-template>
    </nz-divider>
    `,
    styles: [`
    `]
})
export class FcdividerComponent extends FcinputComponent {
     /** é»è®¤æ é¢æ¹å horizontal vertical*/
    @Input()
    fcDirection: string;
     /** èçº¿*/
    @Input()
    fcDashed: string;
    _dashed :boolean = false; 
     /** æå­*/
    @Input()
    fcLabel: string;
     /** æå­ä½ç½®*/
    @Input()
    fcPosition: string;
     /** å·¦ä¾§å¾æ */
    @Input()
    fcLeftIcon: string;
    _leftIcon:boolean=true;
     /** å³ä¾§å¾æ */
    @Input()
    fcRightIcon: string;
    _rightIcon:boolean=false;
     /**å¾æ */
    @Input()
    fcIcon: string;
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-divider');
         /**ä¸ºundefinedæ¶æ°´å¹³æ¾ç¤º*/
        if (this.fcDirection === undefined) {
            this.fcDirection = "horizontal";
        }
         /**ä¸ºundefinedå§ä¸­æ¾ç¤º*/
        if (this.fcPosition === undefined) {
            this.fcPosition = "center";
        }
         /**é»è®¤å¾æ å¨å·¦ä¾§æ¾ç¤º*/
        if (this.fcLeftIcon === undefined || 'N') {
            this._leftIcon = true;
        }
    }
    _afterParentInit(){
         /**å¦æä¸ºYæ¶çº¿æ¡ä¸ºèçº¿*/
        if(this.fcDashed === 'Y'){
            this._dashed = true
        }else{
            this._dashed = false;
        }
         /**å¾æ å¨å·¦ä¾§æ¾ç¤º*/
        if(this.fcLeftIcon === 'Y'){
            this._leftIcon = true
        }else{
            this._leftIcon = false;
        }
         /**å¾æ å¨å³ä¾§*/
        if(this.fcRightIcon === 'Y'){
            this._rightIcon = true;
        }else{
            this._rightIcon = false;
        }
    }
}